import { render, staticRenderFns } from "./DayaDukungBannerChartTrend.vue?vue&type=template&id=3389970a&scoped=true"
import script from "./DayaDukungBannerChartTrend.vue?vue&type=script&lang=js"
export * from "./DayaDukungBannerChartTrend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3389970a",
  null
  
)

export default component.exports